import {Component, Inject, isDevMode, OnInit} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {AngularFireDatabase} from '@angular/fire/compat/database';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {UserRole} from "../../rename/add-user-role/add-user-role.component";
import {take} from "rxjs";

@Component({
    selector: 'app-add-function-menu-dialog',
    templateUrl: './add-function-menu-dialog.component.html',
    styleUrls: ['./add-function-menu-dialog.component.scss']
})
export class AddFunctionMenuDialogComponent implements OnInit {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    functionName = "";
    groupName = "";
    mData: any[]=[]
    mUid: string
  isLoading: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<AddFunctionMenuDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private mDatabase: AngularFireDatabase,
        private firestore : AngularFirestore,
        private mSnackBar: MatSnackBar,
    ) {
        this.mUid = data.uid.trim()
        this.mData = data.permissions
        // alert(data)
    }

    ngOnInit(): void {
    }


  addFunction() {
    this.isLoading = true; // START LOADER

    const functionObj = {
      functionName: this.functionName.trim(),
      group: this.groupName.trim(),
      edit: false,
      add: false,
      archieve: false,
      all: false,
      delete: false,
      view: false,
      showMenu: false,
    };

    Promise.all([
      this.addToAllUsersPermissions(functionObj),
      this.addToAllProfiles(functionObj)
    ])
      .then(() => {
        this.isLoading = false; // STOP LOADER
        this.mSnackBar.open("Function added successfully!", "", { duration: 3000 });
        this.dialogRef.close();
      })
      .catch(err => {
        console.error(err);
        this.isLoading = false; // STOP LOADER
        this.mSnackBar.open("Error while adding function!", "", { duration: 3000 });
      });
  }


   addToAllUsersPermissions(functionObj: any): Promise<void> {
    return new Promise(resolve => {
      this.mDatabase.list("users").snapshotChanges().pipe(take(1)).subscribe(users => {
        let completed = 0;

        users.forEach(user => {
          const uid = user.key;

          this.mDatabase.object(`users/${uid}/permissions`).valueChanges().pipe(take(1))
            .subscribe((permissions: any) => {

              if (!permissions) permissions = [];

              const exists = permissions.some(
                (p:any) =>
                  p?.functionName?.trim().toLowerCase() === functionObj.functionName.trim().toLowerCase() &&
                  p?.group?.trim().toLowerCase() === functionObj.group.trim().toLowerCase()
              );

              if (!exists) {
                permissions.push(functionObj);
                this.mDatabase.object(`users/${uid}/permissions`).set(permissions);
              }

              completed++;
              if (completed === users.length) resolve();
            });

        });
      });
    });
  }
   addToAllProfiles(functionObj: any): Promise<void> {
    return new Promise(resolve => {
      this.firestore.collection(this.env.userPermissions).get().subscribe(snapshot => {
        let completed = 0;

        snapshot.forEach(profileDoc => {
          const profileId = profileDoc.id;

          this.firestore.collection(
            `${this.env.userPermissions}/${profileId}/permissions`,
            ref =>
              ref.where("functionName", "==", functionObj.functionName)
                .where("group", "==", functionObj.group)
          )
            .get()
            .pipe(take(1))
            .subscribe(q => {

              if (q.empty) {
                this.firestore
                  .collection(`${this.env.userPermissions}/${profileId}/permissions`)
                  .add(functionObj);
              }

              completed++;
              if (completed === snapshot.size) resolve();
            });

        });
      });
    });
  }
}
